import React from 'react';
export function PromoVideo() {
  return <section className="py-24 relative overflow-hidden border-t border-white/5 bg-[#0a0a0a]" data-id="element-235" data-mp="6wl2kfzuko80">
      {/* Background glow */}
      <div className="absolute top-1/2 left-0 w-1/2 h-1/2 bg-neon-violet/10 rounded-full mix-blend-screen filter blur-[120px] -translate-y-1/2 pointer-events-none transform-gpu will-change-transform" data-id="element-236" data-mp="3p8lgrana7azd" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 flex flex-col items-center" data-id="element-237" data-mp="gytrycodge8t">
        {/* Text Content */}
        <div className="space-y-6 text-center max-w-3xl mb-12 animate-fade-in-down" style={{
        animationDelay: '0.2s',
        animationFillMode: 'both',
        opacity: 0
      }} data-id="element-238" data-mp="c0ihbzq95zpj">
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight" data-id="element-239" data-mp="lq20l6hvnvkx">
            La Experiencia{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-b from-[#F3E08A] via-[#C9A24A] to-[#8A6A1E]" data-id="element-240" data-mp="zn8dwlju122r">
              Ninja 2.0
            </span>
          </h2>
          <div className="text-gray-400 text-lg leading-relaxed" data-id="element-241" data-mp="38d0pfpr0ifrg">
            <p data-id="element-242" data-mp="3d9r54bywn9cc">
              Adéntrate en nuestro espacio, un entorno diseñado para la
              excelencia donde la cultura urbana y la alta barbería convergen.
              Más que un simple corte de cabello, te ofrecemos un momento de
              desconexión y cuidado personal con las mejores herramientas y
              técnicas.
            </p>
          </div>
        </div>

        {/* Video Player */}
        <div className="relative w-full max-w-5xl animate-fade-in-down" style={{
        animationDelay: '0.4s',
        animationFillMode: 'both',
        opacity: 0
      }} data-id="element-243" data-mp="2poxst1pqvb">
          <div className="rounded-3xl p-[2px] bg-gradient-to-r from-neon-violet via-fuchsia-400 to-neon-green shadow-[0_0_40px_rgba(168,85,247,0.2)]" data-id="element-244" data-mp="9t2a9n8opo2i">
            <div className="rounded-[22px] overflow-hidden bg-black aspect-video relative" data-id="element-245" data-mp="itqmcceipecr">
              <video src="https://cdn.magicpatterns.com/uploads/8QFepnEhNNWBgG5fYJo2xS/Nuestra querida @barberianinja2.0 Una nueva versión de la casa que tanto queremos 💈 Gracias a t (1) (1) (1).mp4" className="w-full h-full object-cover" autoPlay width="1280" height="720" muted loop playsInline controls data-id="element-246" data-mp="2fumqv0b9h3je" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}